/**
 * 学习乐园 · 排排序题材包：天干次序（paixu/pack-tiangan.js）
 * ---------------------------------------------------------------------------
 * 甲乙丙丁戊己庚辛壬癸 10 个全量上场（全集就这十个，抽掉反而漏知识点）。
 * note 按阴阳五行写：甲=阳木、乙=阴木……位次本身就是「五行各分阴阳」的
 * 顺序——排一遍等于把五行两两成对的规律读出来。天干today还在用的地方：
 * 编号（甲乙丙丁=ABCD）、历史纪年、中医处方。
 * items 顺序即正确答案；同包 face 不得重复（排序题天然满足）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.tiangan = {
    id: 'tiangan',
    name: '天干次序',
    hint: '甲到癸十个全量排回',
    cols: 5,
    winText: '甲乙丙丁戊己庚辛壬癸——五行各分阴阳，木火土金水各领一对，十干就齐了。',
    items: [
      { face: '甲', note: '第一位，阳木——像草木破土戴甲' },
      { face: '乙', note: '第二位，阴木——幼苗柔曲生长' },
      { face: '丙', note: '第三位，阳火——太阳之火最明' },
      { face: '丁', note: '第四位，阴火——灯烛之火' },
      { face: '戊', note: '第五位，阳土——城墙厚土' },
      { face: '己', note: '第六位，阴土——田园之土' },
      { face: '庚', note: '第七位，阳金——刀剑之金' },
      { face: '辛', note: '第八位，阴金——首饰之金' },
      { face: '壬', note: '第九位，阳水——江河之水' },
      { face: '癸', note: '第十位，阴水——雨露之水，十干收尾' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
